exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".set-up .content .card {\n  margin: 10px 0; }\n  .set-up .content .card li {\n    margin-bottom: 6px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/faq/set_up/set_up.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/faq/set_up/set_up.scss
// module chunks = index